/**
 * STORE workflow
 */

const state = () => ({
  page: "",
});

const mutations = {
  resetWorkflow(state) {
    Object.keys(state).forEach((k) => {
      state[k] = null;
    });
  },
  setStateData(state, item) {
    state[item.key] = item.value;
  },
};

const getters = {
  getStateData: (state) => (key) => {
    return state[key];
  },
  getActualPage: (state) => {
    return state.page;
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
